import Navbar from "../components/Navbar";

function NotFoundPage() {
  return (
    <div className="NotFoundPage">
      <Navbar/>
      <h1>Страница не найдена</h1>
    </div>
  );
}

export default NotFoundPage;